import PropertyFeatureImage from "@survey-components/propertiesPreview/PropertyFeatureImage";
import { Property } from "@survey-types/survey.property.types";

interface PropertyCardProps {
  property: Property;
  index: number;
}

/**
 * Property Card Component
 * Displays property image with index number overlay
 */
const PropertyCard = ({ property, index }: PropertyCardProps) => {
  return (
    <div className="relative w-full">
      {/* Property Image */}
      <div className="w-full overflow-hidden relative">
        <PropertyFeatureImage
          propertyId={property.propertyId}
          size="thumbnail"
          order={index}
          isShowIcon={true}
          asBackground={true}
          comparison={true}
        />
      </div>
    </div>
  );
};

export default PropertyCard;
